module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_vm._l((props.headers), function(header, index) {
          return _c('th', {
            key: header.text,
            class: ['column', 'subheading', index === 0 ? 'text-xs-left' : 'text-xs-center']
          }, [_vm._v("\n              " + _vm._s(header.text) + "\n            ")])
        }), _vm._v(" "), _c('th')], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return _vm._l((_vm.headers), function(header, index) {
          return (header.value !== '') ? _c('td', {
            key: index,
            class: [index === 0 ? 'text-xs-left' : 'text-xs-center', 'body-2'],
            staticStyle: {
              "white-space": "pre"
            },
            domProps: {
              "innerHTML": _vm._s(_vm.renderData(props.item, header))
            }
          }) : _vm._e()
        })
      }
    }])
  }, [_c('template', {
    slot: "no-data"
  }, [_c('span', [_c('p', {
    staticClass: "pt-2 blue--text subheading"
  }, [_c('v-icon', {
    staticClass: "blue--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("info")]), _vm._v("Sorry, nothing to display here :(")], 1)])])], 2), _vm._v(" "), (_vm.isNotEmpty) ? _c('div', {
    staticClass: "text-xs-center pt-2"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pagination.pages,
      "total-visible": 5,
      "circle": ""
    },
    model: {
      value: (_vm.pagination.page),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "page", $$v)
      },
      expression: "pagination.page"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbcb416a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Table.vue
// module id = 409
// module chunks = 1